"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateFormatByLocale = exports.DATE_FORMATS_12_HOURS = exports.DATE_FORMATS_24_HOURS = exports.DateFormat = void 0;
const tslib_1 = require("tslib");
const moment_1 = tslib_1.__importDefault(require("moment"));
var DateFormat;
(function (DateFormat) {
    DateFormat["Long"] = "Long";
    DateFormat["LongWithDay"] = "LongWithDay";
    DateFormat["LongWithDayNoYear"] = "LongWithDayNoYear";
    DateFormat["LongWithTime"] = "LongWithTime";
    DateFormat["LongWithDayTime"] = "LongWithDayTime";
    DateFormat["LongWithDayTimeAndZone"] = "LongWithDayTimeAndZone";
})(DateFormat = exports.DateFormat || (exports.DateFormat = {}));
exports.DATE_FORMATS_24_HOURS = {
    [DateFormat.Long]: "Do MMM YYYY",
    [DateFormat.LongWithDay]: "ddd, Do MMM YYYY",
    [DateFormat.LongWithDayNoYear]: "ddd, Do MMM",
    [DateFormat.LongWithTime]: "Do MMM YYYY, HH:mm",
    [DateFormat.LongWithDayTime]: "ddd, Do MMM YYYY, HH:mm",
    [DateFormat.LongWithDayTimeAndZone]: "Do MMM YYYY, HH:mm ZZ"
};
exports.DATE_FORMATS_12_HOURS = {
    [DateFormat.Long]: exports.DATE_FORMATS_24_HOURS[DateFormat.Long],
    [DateFormat.LongWithDay]: exports.DATE_FORMATS_24_HOURS[DateFormat.LongWithDay],
    [DateFormat.LongWithDayNoYear]: exports.DATE_FORMATS_24_HOURS[DateFormat.LongWithDayNoYear],
    [DateFormat.LongWithTime]: "Do MMM YYYY, h:mm a",
    [DateFormat.LongWithDayTime]: "ddd, Do MMM YYYY, h:mm a",
    [DateFormat.LongWithDayTimeAndZone]: "Do MMM YYYY, h:mm a ZZ"
};
const isLocaleUsing12Hours = (locale) => {
    var _a;
    if (!locale || locale.length === 0) {
        return true;
    }
    // Special handling while we are trying to figure out how to load different moment locals
    if (locale.toLocaleLowerCase() === "en-il") {
        return false;
    }
    const localeLTFormat = moment_1.default().locale(locale).format("LTS");
    const parts = localeLTFormat.split(" ");
    if (parts.length > 1) {
        const lastPartMeridiem = (_a = parts.pop()) === null || _a === void 0 ? void 0 : _a.toUpperCase();
        if (lastPartMeridiem && (lastPartMeridiem === "AM" || lastPartMeridiem === "PM")) {
            return true;
        }
    }
    return false;
};
exports.dateFormatByLocale = (format, locale) => {
    if (isLocaleUsing12Hours(locale)) {
        return exports.DATE_FORMATS_12_HOURS[format];
    }
    return exports.DATE_FORMATS_24_HOURS[format];
};
//# sourceMappingURL=date.js.map